module.exports = __webpack_public_path__ + "media/src/pages/MyAccount/ProfilePhoto/images/edit-icon-7ee315c8af670821c5aa33d05417d6d7.svg";